import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-licencia',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isOpen) {
    <div class="modal-overlay" [class.closing]="isClosing">
      <div class="modal-content" [class.closing]="isClosing">
        <div class="warning-icon">
          <img src="assets/warning.svg" alt="warning icon" />
        </div>
        <h2>¡Atención!</h2>
        <p>Tu licencia expirará el {{ fechaExpiracion }}</p>
        <button class="button-main" (click)="onClose()">Entendido</button>
      </div>
    </div>
    }
  `,
  styles: [
    `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 1;
        visibility: visible;
        transition: all 0.3s ease;
        z-index: 1000;
      }

      .modal-content {
        background: white;
        padding: 2rem;
        border-radius: 12px;
        text-align: center;
        transform: translateY(0);
        transition: all 0.3s ease;
        max-width: 400px;
        width: 90%;
      }

      .warning-icon {
        margin-bottom: 1rem;
      }

      .warning-icon img {
        width: 64px;
        height: 64px;
      }

      h2 {
        color: #004379;
        margin-bottom: 0.5rem;
      }

      p {
        color: #666;
        margin-bottom: 0.5rem;
      }

      .button-main {
        min-width: 180px;
        margin-top: 1.5rem;
      }

      .modal-overlay.closing {
        opacity: 0;
      }

      .modal-content.closing {
        transform: translateY(20px);
      }
    `,
  ],
})
export class ModalLicenciaComponent {
  @Input() isOpen = false;
  @Input() fechaExpiracion: string = '';
  @Output() close = new EventEmitter<void>();

  isClosing = false;

  onClose(): void {
    this.isClosing = true;
    setTimeout(() => {
      this.close.emit();
      this.isClosing = false;
    }, 300);
  }
}
